<template>
  <section >
    <!-- <filter-component :filters="filters" :showEnd="true" @filter="applyFilters" :types="equipmentTypes" /> -->

    <b-tabs v-model="activeTab" type="is-toggle" style="padding:20px;">
      <b-tab-item :label="`All (${crops.length})`">
        <orders-table :data="crops" :isLoading="isLoading" @reloadOrders="getCrops" :show-status="true">
        </orders-table>
      </b-tab-item>
      <b-tab-item :label="`Maize (${maizeCrops.length})`">
        <orders-table :data="maizeCrops" :isLoading="isLoading" @reloadOrders="getCrops" :show-status="true">
        </orders-table>
      </b-tab-item>

      <b-tab-item :label="`Wheat (${wheatCrops.length})`">
        <orders-table :data="wheatCrops" :isLoading="isLoading" @reloadOrders="getCrops" :show-status="true">
        </orders-table>
      </b-tab-item>

      <b-tab-item :label="`Soya Beans (${soyaBeansCrops.length})`">
        <orders-table :data="soyaBeansCrops" :isLoading="isLoading" @reloadOrders="getCrops" :show-status="true">
        </orders-table>
      </b-tab-item>

      <b-tab-item :label="`Sugar Beans  (${sugarBeansCrops.length})`">
        <orders-table :data="sugarBeansCrops" :isLoading="isLoading" @reloadOrders="getCrops"></orders-table>
      </b-tab-item>


    </b-tabs>
  </section>
</template>

<script>
  import OrdersTable from '@/components/CropManager/Table';
  import FilterComponent from '@/components/Shared/Filters';
  import { mapActions, mapGetters } from "vuex";
  import {
    mdy
  } from '@/helpers';
  export default {
    name: "CropManager",
    components: {
      OrdersTable,
      FilterComponent,
      d:           ['Maize', 'Sorghum', 'Wheat', "Tobbaco", "Sugar Beans", "Soya Beans"]

    },
    computed: {
      ...mapGetters([
        'drivers'
      ]),

      // filters() {
      //   return this.$store.getters.filters;
      // },
      maizeCrops() {
        return this.crops.filter(crop => crop.cropName == "Maize");
      },
      // sorghumCrops() {
      //   return this.crops.filter(crop => crop.cropName == "Sorghum");
      // },
      soyaBeansCrops() {
        return this.crops.filter(crop => crop.cropName == "Soya Beans")
      },
      sugarBeansCrops() {
        return this.crops.filter(crop => crop.cropName == "Sugar Beans")
      },
      wheatCrops() {
        return this.crops.filter(crop => crop.cropName == "Wheat")
      },
      // returnedEquipmentRequests() {
      //   return this.equipmentRequests.filter(order => (order.status == "RETURNED"))
      // },
    },
    data() {
      return {
        crops: [],
        activeTab: 0,
        isLoading: false,
        filter: this.filters,
      }
    },
    created() {
      this.getCrops(this.filters)
    },
    methods: {
      ...mapActions([
        'getDrivers'
      ]),
      getCrops(filters = this.filters) {
        this.crops = [];
        this.isLoading = true;

        this.$store.dispatch('getCrops', filters).then(crops => {
          this.isLoading = false;
          this.crops = crops
          console.log(crops)
        }).catch(e => {
          console.log(`Exception when getting  crops, e:${e}`);
          this.isLoading = false;
        })
      },

      applyFilters({
        start,
        end,
        mobile_number,
        // cropName,
        requestNumber,
        deliveryCities,
        equipmentTypeId
      }) {
        end.setHours(24)
        const fromDate = mdy(start);
        const toDate = mdy(end);
        this.$store.commit('setFilters', {
          fromDate,
          toDate,
          mobile_number,
          cropName,
          requestNumber,
          deliveryCities,
          equipmentTypeId
        });
        this.getCrops();
      },
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/CropManager/Home.vue